module.exports = __webpack_public_path__ + "img/email1.b740278e.png";